module.exports = __webpack_public_path__ + "img/orgchart.a58ca171.png";